import { createUseStyles } from 'react-jss'
import { colors, zIndexes, styleFragments } from '../../../variables.style'

export const style = {
  navbar: {
    ...styleFragments.baseHeaderFont,
    composes: 'flex-row',
    backgroundColor: 'var(--theme-navbar-bg)',
    alignItems: 'end',
    zIndex: zIndexes.navbar,
    overflow: 'auto',
    borderBottom: `3px solid var(--theme-navbar-border)`
  },
  logo: {
    display: 'block',
    maxHeight: '46px',
    // maxWidth: '175px',
    margin: '10px 20px 8px 20px'
    // margin: '0px 20px 0px 15px'
  },
  logoText: {
    display: 'inline-block',
    width: 'auto',
    color: 'var(--theme-navbar-fg)',
    fontSize: '20px',
    marginRight: 20
  },
  navbarEnd: {
    composes: 'flex-auto flex-row',
    justifyContent: 'flex-end',
    width: '100%',
    alignItems: 'center'
  },
  menuContainer: {
    composes: 'flex-row',
    flexShrink: 1,
    minWidth: '75px'
  }
}

export const useStyles = createUseStyles(style)
